import {
  DEFAULT_CTA_LABEL,
  DEFAULT_HEIGHT,
  DEFAULT_RESTAURANT_ID,
  getDisplay,
} from './utils';

const schema = ({ data }: any) => {
  const display = getDisplay(data?.display);

  return {
    title: 'Réservation en ligne',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['eyebrow', 'heading', 'description'],
      },
      {
        id: 'widget',
        title: 'Module Zenchef',
        fields: [
          'display',
          'restaurant_id',
          display === 'button' ? 'cta_label' : 'height',
        ],
      },
    ],
    properties: {
      eyebrow: {
        title: 'Surtitre',
        type: 'string',
        default: 'Réserver',
      },
      heading: {
        title: 'Titre',
        type: 'string',
        default: 'Réservez votre table en ligne.',
      },
      description: {
        title: 'Description',
        type: 'string',
        widget: 'textarea',
        default:
          'Choisissez votre date, votre service et le nombre de convives. Vous recevez une confirmation immédiate.',
        description: 'Une ou deux phrases affichées à côté du module.',
      },
      display: {
        title: 'Affichage',
        type: 'string',
        choices: [
          ['embed', 'Module intégré dans la page'],
          ['button', 'Bouton qui ouvre le module'],
        ],
        default: 'embed',
        description:
          'Le module intégré prend la couleur du bandeau choisi dans l’onglet Style.',
      },
      restaurant_id: {
        title: 'Identifiant du restaurant',
        type: 'string',
        default: DEFAULT_RESTAURANT_ID,
        description:
          'Le « rid » de l’adresse du module Zenchef (bookings.zenchef.com/results?rid=…).',
      },
      cta_label: {
        title: 'Texte du bouton',
        type: 'string',
        default: DEFAULT_CTA_LABEL,
      },
      height: {
        title: 'Hauteur du module (px)',
        type: 'number',
        default: DEFAULT_HEIGHT,
        description: 'Entre 320 et 1200 pixels.',
      },
    },
    required: [],
  };
};

export default schema;
